// The app doesn't use a service worker. This removes any that an old (CRA)
// build registered, so it stops serving cached assets.
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
